import { useScreenSize } from '@/hooks';

type GlobalIconProps = {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
};

const GlobalIcon = ({ color = 'currentColor', width = 18, height = 18, className }: GlobalIconProps) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <circle cx="9" cy="9" r="8.4" stroke={color} stroke-width="1.2" />
            <path
                d="M9 0.599609C9.89294 0.599609 10.8631 1.3394 11.6455 2.9043C12.41 4.4333 12.9004 6.58768 12.9004 9C12.9004 11.4123 12.41 13.5667 11.6455 15.0957C10.8631 16.6606 9.89294 17.4004 9 17.4004C8.10706 17.4004 7.13694 16.6606 6.35449 15.0957C5.58999 13.5667 5.09961 11.4123 5.09961 9C5.09961 6.58768 5.58999 4.4333 6.35449 2.9043C7.13694 1.3394 8.10706 0.599609 9 0.599609Z"
                stroke={color}
                stroke-width="1.2"
            />
            <line x1="1" y1="6.4" x2="17" y2="6.4" stroke={color} stroke-width="1.2" />
            <line x1="1" y1="12.4" x2="17" y2="12.4" stroke={color} stroke-width="1.2" />
        </svg>
    );
};

export default GlobalIcon;
